import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../apiBase';

export default function ParentLinkChild() {
    const { t } = useTranslation(['common']);
    const [query, setQuery] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const token = localStorage.getItem('token');
    const api = axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    async function handleSearch(e) {
        e?.preventDefault();
        if (!query.trim()) return;
        setBusy(true);
        setError('');
        setStatus('searching');
        try {
            await api.post('/parent/link-request', { searchQuery: query.trim() });
            setStatus('pending');
        } catch (err) {
            const code = err.response?.data?.error;
            if (code === 'student_not_found') {
                setError(t('parent.studentNotFound', { defaultValue: 'Ученик не найден. Проверьте email или телефон.' }));
            } else if (code === 'already_linked') {
                setError(t('parent.alreadyLinked', { defaultValue: 'Вы уже привязаны к этому ученику.' }));
            } else {
                setError(err.response?.data?.message || err.response?.data?.error || t('common:error'));
            }
            setStatus('error');
        }
        setBusy(false);
    }

    return (
        <div style={{ maxWidth: 480, margin: '0 auto', padding: '24px 16px' }}>
            <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>{t('parent.findChild')}</h2>
            <p style={{ color: '#666', margin: '0 0 20px', fontSize: 14, lineHeight: 1.5 }}>
                {t('parent.findChildHint')}
            </p>

            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder={t('parent.searchPlaceholder')}
                    style={{
                        width: '100%',
                        padding: '12px 14px',
                        borderRadius: 10,
                        border: '1.5px solid #e2e8f0',
                        fontSize: 14,
                        boxSizing: 'border-box',
                        marginBottom: 12,
                    }}
                />
                <button
                    type="submit"
                    disabled={busy || !query.trim()}
                    style={{
                        width: '100%',
                        padding: '13px',
                        background: '#EB3333',
                        color: 'white',
                        border: 'none',
                        borderRadius: 10,
                        fontWeight: 700,
                        cursor: busy ? 'wait' : 'pointer',
                        opacity: busy || !query.trim() ? 0.7 : 1,
                    }}
                >
                    {busy ? t('common:loading') : t('parent.sendRequest')}
                </button>
            </form>

            {status === 'pending' && (
                <div style={{
                    marginTop: 20,
                    padding: 16,
                    background: '#e8f5e9',
                    borderRadius: 10,
                    color: '#2e7d32',
                    fontSize: 14,
                }}>
                    ✅ {t('parent.requestSent')}
                </div>
            )}

            {error && (
                <div style={{
                    marginTop: 16,
                    padding: 12,
                    background: '#fce4ec',
                    borderRadius: 10,
                    color: '#c62828',
                    fontSize: 13,
                }}>
                    {error}
                </div>
            )}
        </div>
    );
}
